// Standard library imports
import React from 'react';

// Internal Module Imports
import AreaEnergyRevenue from './AreaEnergyRevenue';
import TabsComponent from '../../../../components/Tabs/Tabs';

const AreaEnergyRevenueIndex = ({ data, setOpen }) => {
    const tabs = [
        { name: 'aFRR', component: <AreaEnergyRevenue data={{ ...data, market: 'aFRR' }} setOpen={setOpen} />, tabId: 1 },
        { name: 'mFRR', component: <AreaEnergyRevenue data={{ ...data, market: 'mFRR' }} setOpen={setOpen} />, tabId: 2 },
    ];

    return <TabsComponent tabs={tabs} selectedIndex={0} />;
};

export default AreaEnergyRevenueIndex;
